import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import toastMessage from '@/plugins/ToastMessage'
import toast from '@/plugins/Toast'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import MetaInfo from 'vue-meta-info'
import VConsole from 'vconsole'
import 'video.js/dist/video-js.css'

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(MetaInfo);
Vue.use(VueAwesomeSwiper, /* { default global options } */);
Vue.use(toastMessage);
Vue.use(toast);

if (process.env.NODE_ENV === 'development') {
  new VConsole()
}


/* eslint-disable no-new */
Vue.filter('abs', function (v) {
  return Math.abs(v);
});

Vue.filter('timeFilter', function (timestamp) {
  var date=new Date(timestamp);
  var year=date.getFullYear();
  var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
  var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
  var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
  var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
  var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();

  return year+"-"+month+"-"+day+" "+hours+":"+minutes+":"+seconds;
});
Vue.filter('timeFilterSimple', function (timestamp) {
  var date=new Date(timestamp);
  var year=date.getFullYear();
  var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
  var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
  return year+"-"+month+"-"+day;
});
Vue.filter('slotTimeFilter',function(timestamp){
  var nowStamp=new Date().getTime();

  var diffSec = (nowStamp-timestamp)/1000;
  if(diffSec < 5*60){
    return "刚刚";
  }
  if(diffSec < 60*60){
    return (diffSec/60).toFixed(0)+"分前";
  }
  if(diffSec < 24*60*60){
    return (diffSec/(60*60)).toFixed(0)+"小时前";
  }
  if(diffSec < 24*60*60*5){
    return (diffSec/(24*60*60)).toFixed(0)+"天前";
  }

  var date=new Date(timestamp);
  var year=date.getFullYear();
  var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
  var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();

  return year+"-"+month+"-"+day;
});

Vue.filter('mmddFilter', function (timestamp) {
  var date=new Date(timestamp);
  var year=date.getFullYear();

  var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
  var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();

  return month+"月"+day+"日";
});

Vue.filter('imgFilter',function(url,w,h){
  return url+'?imageView2/1/w/'+w+'/h/'+h;
});

Vue.filter('numFilter',function(value){
  var value=Math.round(parseFloat(value)*100)/100;
  var xsd=value.toString().split(".");
  if(xsd.length==1){
    //value=value.toString()+".00";
    return value;
  }
  if(xsd.length>1){
    if(xsd[1].length<2){
    value=value.toString()+"0";
    }
    return value;
  }
});

Vue.filter('num2Bit',function(value){
  if(value<10){
    return "0"+value;
  }
  return value;
});

Vue.filter('millSecondFirstBit',function(value){
  var t= (value/100).toFixed(0);
  if(t>=10){
    t=0;
  }
  return t;
});

var common =function() {
  return{
    gotoClick:function(url){
      location.href=url;
    },
    imgCut:function(url,w,h){
      if(url==null ||url=="" || typeof(url)=="undefined"){
        return '';
      }
      return url+'?imageView2/1/w/'+w+'/h/'+h;
    },
    imgCutW:function(url,w){
      if(url==null ||url=="" || typeof(url)=="undefined"){
        return '';
      }
      return url+'?imageView2/2/w/'+w;
    },

    isEmpty:function(val){
      return val==null || val=='' || typeof(val)=="undefined" ;
    },
    isNotEmpty:function(val){
      return val!=null && val!='' && typeof(val)!="undefined" ;
    }
  }
}();
if(typeof(Vue)=="function"){
  Vue.prototype.common=common;
}

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js